import { ReactNode } from 'react';
import { CardMedia, Typography, CardProps } from '@mui/material';

import { GradientBorderCard, StyledCardContainer } from './HowItWorkCard.styles';

interface HowItWorksCardProps extends Omit<CardProps, 'component'> {
    component?: 'img' | 'picture';
    title: string;
    descriptions: string[];
    image?: string;
    children?: ReactNode;
}

const HowItWorkCard = ({ component = 'img', title, descriptions, image, children, ...props }: HowItWorksCardProps) => {
    return (
        <GradientBorderCard {...props}>
            <CardMedia
                component={component}
                height="128"
                image={image}
                alt={title}
                sx={{
                    objectFit: 'contain',
                }}
            >
                {children}
            </CardMedia>
            <StyledCardContainer>
                <Typography variant="h5" color="#fff" sx={{ fontSize: '20px', fontWeight: 500, mb: '14px' }}>
                    {title}
                </Typography>
                {descriptions.map((description, index) => (
                    <Typography key={index} variant="body2" color="#A3A5B0" sx={{ fontSize: '16px', fontWeight: 300, textAlign: 'center' }}>
                        {description}
                    </Typography>
                ))}
            </StyledCardContainer>
        </GradientBorderCard>
    );
};

export default HowItWorkCard;
